export default class ModalAlert {
  constructor() {
    this.storageKey = 'ecovia-alert-dismissed';
    this.checkAndShowAlert();
  }

  checkAndShowAlert() {
    // Verifica se o utilizador já fechou o alerta
    const isDismissed = localStorage.getItem(this.storageKey);
    
    // Se não foi fechado anteriormente, mostra o alerta
    if (!isDismissed) {
      this.createAlertModal();
    }
  }

  createAlertModal() {
    // Cria o container do modal
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'modal-alert-overlay';
    modalOverlay.id = 'modal-alert';

    // HTML do modal
    modalOverlay.innerHTML = `
      <div class="modal-alert-container">
        <div class="modal-alert-header">
          <i class="fas fa-exclamation-triangle"></i>
          <button class="modal-alert-close" aria-label="Fechar alerta">
            <i class="fas fa-times"></i>
          </button>
        </div>
        
        <div class="modal-alert-content">
          <p>Informamos todos os utilizadores que, devido às condições meteorológicas adversas que se têm feito sentir na nossa região, existem atualmente vários segmentos da rota intransitáveis em grande parte do percurso.</p>

          <p>Solicita-se a máxima cautela na utilização da via até novas informações.</p>

          <p><strong>Foram identificadas as seguintes situações de risco:</strong></p>
          <ul>
            <li>Arribas instáveis</li>
            <li>Proteções de via ausentes</li>
            <li>Derrocadas na via</li>
            <li>Via submersa</li>
          </ul>

          <p>Antes de iniciar o percurso, por favor informe-se junto das autoridades locais sobre o estado atualizado da Ecovia.</p>

          <p>Agradecemos a compreensão e colaboração de todos.</p>
        </div>

        <div class="modal-alert-footer">
          <button class="modal-alert-btn-close">Fechar</button>
        </div>
      </div>
    `;

    // Adiciona o modal ao body
    document.body.appendChild(modalOverlay);

    // Event listeners para fechar
    const closeButton = modalOverlay.querySelector('.modal-alert-close');
    const closeButtonFooter = modalOverlay.querySelector('.modal-alert-btn-close');

    closeButton.addEventListener('click', () => this.dismissAlert(modalOverlay));
    closeButtonFooter.addEventListener('click', () => this.dismissAlert(modalOverlay));
    
    // Fecha ao clicar no overlay
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) {
        this.dismissAlert(modalOverlay);
      }
    });
  }

  dismissAlert(modalElement) {
    // Guarda no localStorage que o utilizador fechou o alerta
    localStorage.setItem(this.storageKey, 'true');
    
    // Remove o elemento do DOM com animação
    modalElement.classList.add('closing');
    setTimeout(() => {
      modalElement.remove();
    }, 300);
  }
}
